/* eslint-disable jira/naming/disallow-filenames */

import type { RouteResource } from '@atlassian/react-resource-router';
import { staticSidebarJSWReportsResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-jsw-reports-sidebar/index.tsx';
import { staticProjectReportsSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-reports-connect-addons/index.tsx';
import type { JiraSoftwareReport } from '@jira/navigation-apps__resources/src/services/sidebar/jsw-reports-sidebar-navigation/types.tsx';
import type { ProjectSidebarAddonNavItem } from '@jira/navigation-apps__resources/src/services/sidebar/project-sidebar-connect-addons-navigation/types.tsx';
import { devOpsReportPreconditionResource } from '@jira/router-resources__devops-report-group/src/devOpsReportPreconditionResource.tsx';
import type { PreconditionResult } from '@jira/router-resources__devops-report-group/src/PreconditionResult.types.tsx';

export const getReportsCommonResource = (): (
	| RouteResource<PreconditionResult>
	| RouteResource<ProjectSidebarAddonNavItem[] | null>
)[] => [
	devOpsReportPreconditionResource,
	staticProjectReportsSidebarConnectAddonsNavigationResource,
];

export const getTMPReportsCommonResource = (): (
	| RouteResource<PreconditionResult>
	| RouteResource<ProjectSidebarAddonNavItem[] | null>
	| RouteResource<JiraSoftwareReport[] | null>
)[] => [
	devOpsReportPreconditionResource,
	staticProjectReportsSidebarConnectAddonsNavigationResource,
	staticSidebarJSWReportsResource,
];
